import { summaryTableStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsSummaryTable";
import { totalStyles } from "@insite/content-library/Widgets/InvoiceDetails/InvoiceDetailsTotal";
import { filterStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { headerStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryHeader";
import { tableStyles } from "@insite/content-library/Widgets/InvoiceHistory/InvoiceHistoryTable";
import { ButtonWrapper } from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { GridOffset } from "@insite/mobius/GridContainer";
import { IconWrapper } from "@insite/mobius/Icon";
import { horizontalStyles } from "@insite/mobius/Tag";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

summaryTableStyles.title = {
    variant: "h5",
    css: css`
        @media print {
            font-size: 15px;
        }
        width: 100%;
        background-color: ${getColor("info.contrast")};
        padding: 10px 17px;
        margin-top: 10px !important;
        margin-bottom: 10px !important;
    `,
}

totalStyles.labelGridItem = {
    width: 6,
    css: css`
        >${TypographyStyle}{
            color: ${getColor("secondary")};
        }
    `
}

totalStyles.valueGridItem = {
    width: 6,
    css: css`
        >${TypographyStyle}{
            color: ${getColor("secondary")};
        }
    `
}

tableStyles.dataTable = {
    css: css`
    >thead{
        > tr[class^="DataTableHeadStyle"] {
            >${DataTableCellBase}{
                border-bottom: 1px solid ${getColor("common.border")};
                background: ${getColor("info.contrast")};
                >${StyledButton}{
                    ${TypographyStyle}{
                        font-size: 16px;
                        color: ${getColor("primary")};
                    }
                    ${IconWrapper}{
                        color: ${getColor("primary")};
                    }
                }
            }
        }
    }
    >tbody{
        > tr[class^="DataTableRowStyle"] {
            >${DataTableCellBase}{
                >${TypographyStyle}{
                    font-size: 16px;
                    color: ${getColor("secondary")};
                }
            }
        }
    }
    `
}

filterStyles.appliedFiltersContainer = {
    css: css`
        ${horizontalStyles}
        > div[class^="TagStyle"] {
            background-color: ${getColor("primary")};
            color: ${getColor("primary.contrast")};
            >${TypographyStyle}{
                margin: 6px 10px 1px 0;
            }
            > ${ButtonWrapper} {
                background: ${getColor("primary")};
                &:hover {
                    background: #234c9a;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary.contrast")};
                }
            }
        }
    `,
};
filterStyles.onlyOpenGridItem = {
    width: [12, 12, 3, 3, 3],
    align: "bottom",
    css: css`
        padding-top: 0;
    `,
};
filterStyles.buttonsItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        justify-content: flex-end;
        align-items: flex-end;
        > ${ButtonWrapper} {
            margin-right: 0px;
        }
    `,
};

filterStyles.headingItem = {
    width: 12,
    css: css`
        padding: 10px 10px 10px 15px;
        background-color: ${getColor("info.contrast")};
    `,
};

filterStyles.heading = {
    variant: "h5",
    css: css`
        margin: 0px;
    `,
};

filterStyles.container = {
    css: css`
        padding-bottom: 15px;
        > ${GridOffset} {
            width: 100%;
            margin: 0px;
        }
    `,
};

filterStyles.shipToGridItem = {
    width: [12, 12, 6, 6, 4],
};
filterStyles.invoiceNumberGridItem = {
    width: [12, 12, 3, 3, 3],
};
filterStyles.orderNumberGridItem = {
    width: [12, 12, 3, 3, 3],
};
filterStyles.poNumberGridItem = {
    width: [12, 12, 3, 3, 2],
};
filterStyles.fromGridItem = {
    width: [6, 6, 3, 3, 2],
};
filterStyles.toGridItem = {
    width: [6, 6, 3, 3, 2],
};
filterStyles.onlyOpenCheckbox = {
    css: css`
        > ${TypographyStyle} {
            font-size: 14px;
        }
    `,
};

headerStyles.toggleFilterIcon = { size: 24, color: "primary" };

headerStyles.heading = {
    variant: "h1",
};
